import React from "react";
import { useGetObjectTypesForSettingsQuery } from "../../../../generated/graphql";
import { Box } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Buttons/Button";
import { Header, HeaderTitle } from "../../__styles__/Content";
import { ContentWrapper } from "./__styles__/MapObjects";
import MapObjectsGrid from "./MapObjectsGrid";
import { useUpsertCustomMapModal } from "./UpsertCustomMapModal";
import { useDeleteCustomMapModal } from "./useDeleteCustomMapWithConfirmation";

const MapObjects = () => {
  const { data, loading, refetch } = useGetObjectTypesForSettingsQuery();

  const [showUpsertModal] = useUpsertCustomMapModal({
    onSave: () => void refetch(),
  });
  const showDeleteModal = useDeleteCustomMapModal({
    onDelete: () => void refetch(),
  });

  const customMaps =
    data?.account?.customMaps.filter(map => map.isObject) ?? [];

  return (
    <Box>
      <Header accountSettings>
        <HeaderTitle accountSettings>Map objects</HeaderTitle>
        <Button
          variant="outline"
          size="small"
          iconStart="plus"
          onPress={() => showUpsertModal()}
          title="Add"
        />
      </Header>

      <ContentWrapper>
        {loading ?
          <div>Loading...</div>
        : <MapObjectsGrid
            customMaps={customMaps}
            showEditModal={showUpsertModal}
            showDeleteModal={showDeleteModal}
          />
        }
      </ContentWrapper>
    </Box>
  );
};

export default MapObjects;
